'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

var _validateUrlUserinfo = require('./validateUrlUserinfo');

var _validateUrlUserinfo2 = _interopRequireDefault(_validateUrlUserinfo);

var _validateUrlHost = require('./validateUrlHost');

var _validateUrlHost2 = _interopRequireDefault(_validateUrlHost);

var _validateUrlPort = require('./validateUrlPort');

var _validateUrlPort2 = _interopRequireDefault(_validateUrlPort);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

var validateUrlAuthority = (0, _regexSupplant2.default)(
// $1 userinfo
'(?:(#{validateUrlUserinfo})@)?' +
// $2 host
'(#{validateUrlHost})' +
// $3 port
'(?::(#{validateUrlPort}))?', { validateUrlUserinfo: _validateUrlUserinfo2.default, validateUrlHost: _validateUrlHost2.default, validateUrlPort: _validateUrlPort2.default }, 'i');

exports.default = validateUrlAuthority;
module.exports = exports['default'];